import { useState, useEffect } from 'react'

// Components
import { Button, IconCheck, IconPen } from '@tracklib/kit'
import { Input, Select } from 'components/form/inputs'

// Types
import type { Distributor as DistributorType } from 'components/interestform/slides/cataloginformation/cataloginformation'

// Utils
import styles from './distributor.css'

type DistributorProps = {
  onReview: boolean
  distributorData: {
    distributor: string
    otherDistributor: string
  }
  distributorOptions: Array<DistributorType>
}

const validateDistributor = (value: string) => {
  if (value === '') {
    return 'You must select a distributor, or enter your own'
  }
  return ''
}

const validateOtherDistributor = (value: string) => {
  if (value === '') {
    return 'Are you sure? This name seems too short'
  }
  return ''
}

const Distributor = (props: DistributorProps): JSX.Element => {
  const { onReview, distributorData, distributorOptions } = props
  const [isEditing, setIsEditing] = useState(true)

  const { distributor, otherDistributor } = distributorData

  useEffect(() => {
    if (onReview) {
      setIsEditing(false)
    }
  }, [onReview])

  if (!isEditing) {
    return (
      <div className={styles.displayWrapper}>
        <div className={styles.dataWrapper}>
          {distributor !== 'Other' && (
            <div className={styles.listItem}>
              <div className={styles.textData}>{distributor}</div>
            </div>
          )}
          {distributor === 'Other' && (
            <div className={styles.listItem}>
              <div className={styles.textData}>{otherDistributor}</div>
            </div>
          )}
        </div>
        {onReview && !isEditing && (
          <Button className={styles.btnEdit} variant="outline" onClick={() => setIsEditing(!isEditing)}>
            <IconPen />
          </Button>
        )}
      </div>
    )
  }

  return (
    <div className={styles.editingWrapper}>
      <div className={styles.selectWrapper}>
        <Select
          className={styles.distributorSelect}
          id="distributor"
          name="distributor"
          options={distributorOptions.map(x => ({ id: x.distributor_name, label: x.distributor_name }))}
          placeholder="Select your distributor"
          validate={validateDistributor}
        />
        {distributor === 'Other' && (
          <Input
            id="other_distributor"
            name="other_distributor"
            type="text"
            label="Distributor name"
            placeholder="Enter distributor name"
            validate={validateOtherDistributor}
          />
        )}
      </div>
      {onReview && isEditing && (
        <Button className={styles.btnEditConfirm} onClick={() => setIsEditing(!isEditing)}>
          <IconCheck />
        </Button>
      )}
    </div>
  )
}

export default Distributor
